<template>
  <section class="content-categories-default">
    <Breadcrumb :links="links"/>
    <div class="content-categories-default-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="category in meditationCategories" :key="category.id">
          <CardCategory :category="category" :isType="'Meditation'"/>
        </div>
      </div>
    </div>
    <ModalDelete/>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardCategory from '@/components/cards/CardCategory';
import ModalDelete from '@/components/modals/ModalDelete';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Categorias',
          routerName: 'ListMeditationCategories'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
    CardCategory,
    ModalDelete
  },
  computed: {
    ...mapGetters('Meditation', ['meditationCategories'])
  },
  methods: {
    ...mapActions('Meditation', ['consultCategoriesMeditation', 'registerCategoryMeditation'])
  },
  mounted() {
    this.consultCategoriesMeditation();
  }
}
</script>

<style lang="scss">
</style>
